export default "af6d7e59522be4d4.png"